import { TagType } from "@core/models";

const TAG_CHIP_CLASS_BY_TYPE: Record<TagType, string> = {
  INTERNAL: "tag-chip--internal",
  PUBLIC: "tag-chip--public"
};

export function getTagChipClassName(tagType?: TagType): string {
  if (!tagType) {
    return TAG_CHIP_CLASS_BY_TYPE.PUBLIC;
  }

  return TAG_CHIP_CLASS_BY_TYPE[tagType] || TAG_CHIP_CLASS_BY_TYPE.PUBLIC;
}
